module.exports = __webpack_public_path__ + "img/1.1ff749a2.png";